import { models } from '@kurtosys/ksys-app-template';
export const AUTHENTICATION: models.appsInitialize.IAppAuthentication = {
	token: '49907d96-9d9e-4576-8cfd-b9af0a2d7ad7',
	serviceUrl: 'https://api-rel.fundpress.io',
};